import React, { useState } from 'react';
import { Lock } from 'lucide-react';
import { api } from '../api';
import './Login.css';

export default function ResetPassword({ token, onDone }) {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [status, setStatus] = useState('idle'); // 'idle' | 'submitting' | 'success'
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirm) {
      setError('Passwords do not match');
      return;
    }
    if (
      password.length < 10 ||
      !/[A-Za-z]/.test(password) ||
      !/[0-9]/.test(password)
    ) {
      setError(
        'Password must be at least 10 characters and include at least one letter and one number'
      );
      return;
    }

    setStatus('submitting');
    try {
      await api.resetPassword(token, password);
      setStatus('success');
    } catch (err) {
      setError(err.message || 'Failed to reset password');
      setStatus('idle');
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>Choose a new password</h1>
          <p>Enter and confirm your new password below</p>
        </div>

        {status === 'success' ? (
          <div className="auth-form">
            <div
              className="auth-success"
              style={{
                background: '#ecfdf5',
                color: '#065f46',
                padding: 16,
                borderRadius: 8,
                marginBottom: 16,
              }}
            >
              Your password has been reset successfully. You can now sign in
              with your new password.
            </div>
            <button type="button" className="auth-button" onClick={onDone}>
              Go to Sign In
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-group">
              <label htmlFor="password">New Password</label>
              <div className="input-wrapper">
                <Lock size={18} className="input-icon" />
                <input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="New password"
                  required
                  minLength={10}
                />
              </div>
              <p
                className="password-hint"
                style={{ fontSize: 12, color: '#666', marginTop: 4 }}
              >
                At least 10 characters, including a letter and a number
              </p>
            </div>

            <div className="form-group">
              <label htmlFor="confirm">Confirm Password</label>
              <div className="input-wrapper">
                <Lock size={18} className="input-icon" />
                <input
                  id="confirm"
                  type="password"
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  placeholder="Confirm new password"
                  required
                  minLength={10}
                />
              </div>
            </div>

            {error && <div className="auth-error">{error}</div>}

            <button
              type="submit"
              className="auth-button"
              disabled={status === 'submitting'}
            >
              {status === 'submitting' ? 'Resetting...' : 'Reset password'}
            </button>

            <div style={{ textAlign: 'center', marginTop: 12 }}>
              <button
                type="button"
                onClick={onDone}
                className="auth-link"
                style={{ background: 'none', border: 'none', cursor: 'pointer' }}
              >
                Back to Sign In
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
